import TextValueEditor from './editors/text/TextValueEditor.svelte';
import NumberValueEditor from './editors/number/NumberValueEditor.svelte';
import ObjectValueEditor from './meta-editors/object/ObjectValueEditor.svelte';
import type {ValueEditorConfigurationManagerProvider} from './configuration/value-editor-configuration-manager.provider';
import type {ValueEditorLocalizationManagerProvider} from './localizations/value-editor-localization-manager.provider';
import ListValueEditor from './meta-editors/list/ListValueEditor.svelte';
import type {ValueEditorRegistrationService} from './editor-type-registration/value-editor-registration.service';
import {TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, TEXT_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/text/defaults';
import {LIST_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, LIST_VALUE_EDITOR_DEFAULT_OPTIONS} from './meta-editors/list/defaults';
import {OBJECT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, OBJECT_VALUE_EDITOR_DEFAULT_OPTIONS} from './meta-editors/object/defaults';
import {
    NUMBER_VALUE_EDITOR_DEFAULT_LOCALIZATIONS,
    NUMBER_VALUE_EDITOR_DEFAULT_OPTIONS
} from './editors/number/defaults';
import GenerableTextValueEditor from './editors/generable-text/GenerableTextValueEditor.svelte';
import {GENERABLE_TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, GENERABLE_TEXT_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/generable-text/defaults';
import {TEXT_OR_SELECT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, TEXT_OR_SELECT_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/text-or-select/defaults';
import TextOrSelectValueEditor from './editors/text-or-select/TextOrSelectValueEditor.svelte';
import TextWithMetadataValueEditor from './editors/text-with-metadata/TextWithMetadataValueEditor.svelte';
import {TEXT_WITH_METADATA_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, TEXT_WITH_METADATA_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/text-with-metadata/defaults';
import ScannableTextValueEditor from './editors/scannable-text/ScannableTextValueEditor.svelte';
import {SCANNABLE_TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, SCANNABLE_TEXT_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/scannable-text/defaults';
import YearValueEditor from './editors/year/YearValueEditor.svelte';
import {YEAR_VALUE_EDITOR_DEFAULT_LOCALIZATIONS} from './editors/year/defaults';
import {DATE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, DATE_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/date/defaults';
import DateValueEditor from './editors/date/DateValueEditor.svelte';
import HtmlValueEditor from './editors/html/HtmlValueEditor.svelte';
import {HTML_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, HTML_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/html/defaults';
import PasswordValueEditor from './editors/password/PasswordValueEditor.svelte';
import {PASSWORD_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, PASSWORD_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/password/defaults';
import BooleanValueEditor from './editors/boolean/BooleanValueEditor.svelte';
import {BOOLEAN_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, BOOLEAN_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/boolean/defaults';
import HiddenValueEditor from './editors/hidden/HiddenValueEditor.svelte';
import RangeValueEditor from './editors/range/RangeValueEditor.svelte';
import {RANGE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, RANGE_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/range/defaults';
import AutocompleteValueEditor from './editors/autocomplete/AutocompleteValueEditor.svelte';
import {
    AUTOCOMPLETE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS,
    AUTOCOMPLETE_VALUE_EDITOR_DEFAULT_OPTIONS
} from './editors/autocomplete/defaults';
import SearchOrEditValueEditor from './editors/search-or-edit/SearchOrEditValueEditor.svelte';
import {SEARCH_OR_EDIT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, SEARCH_OR_EDIT_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/search-or-edit/defaults';
import NumberRangeValueEditor from './editors/number-range/NumberRangeValueEditor.svelte';
import {NUMBER_RANGE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS, NUMBER_RANGE_VALUE_EDITOR_DEFAULT_OPTIONS} from './editors/number-range/defaults';
import SingleAcceptableValueEditor from './editors/single-acceptable/SingleAcceptableValueEditor.svelte';
import {
    SINGLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS,
    SINGLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_OPTIONS
} from './editors/single-acceptable/defaults';
import MultipleAcceptableValueEditor from './editors/multiple-acceptable/MultipleAcceptableValueEditor.svelte';
import {
    MULTIPLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS,
    MULTIPLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_OPTIONS
} from './editors/multiple-acceptable/defaults';
import AcceptableRootValueEditor from './editors/acceptable-root/AcceptableRootValueEditor.svelte';
import {
    ACCEPTABLE_ROOT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS,
    ACCEPTABLE_ROOT_VALUE_EDITOR_DEFAULT_OPTIONS
} from './editors/acceptable-root/defaults';


/*@ngInject*/
export function valueEditorsRegistrationConfig(valueEditorRegistrationService: ValueEditorRegistrationService,
                                               valueEditorConfigurationManagerProvider: ValueEditorConfigurationManagerProvider,
                                               valueEditorLocalizationManagerProvider: ValueEditorLocalizationManagerProvider) {
    valueEditorRegistrationService
        .registerEditorComponent('text', TextValueEditor)
        .registerEditorComponent('number', NumberValueEditor)
        .registerEditorComponent('object', ObjectValueEditor)
        .registerEditorComponent('list', ListValueEditor)
        .registerEditorComponent('generable-text', GenerableTextValueEditor)
        .registerEditorComponent('text-or-select', TextOrSelectValueEditor)
        .registerEditorComponent('text-with-metadata', TextWithMetadataValueEditor)
        .registerEditorComponent('scannable-text', ScannableTextValueEditor)
        .registerEditorComponent('year', YearValueEditor)
        .registerEditorComponent('date', DateValueEditor)
        .registerEditorComponent('html', HtmlValueEditor)
        .registerEditorComponent('password', PasswordValueEditor)
        .registerEditorComponent('boolean', BooleanValueEditor)
        .registerEditorComponent('hidden', HiddenValueEditor)
        .registerEditorComponent('range', RangeValueEditor)
        .registerEditorComponent('autocomplete', AutocompleteValueEditor)
        .registerEditorComponent('search-or-edit', SearchOrEditValueEditor)
        .registerEditorComponent('number-range', NumberRangeValueEditor)
        .registerEditorComponent('single-acceptable', SingleAcceptableValueEditor)
        .registerEditorComponent('multiple-acceptable', MultipleAcceptableValueEditor)
        .registerEditorComponent('acceptable-root', AcceptableRootValueEditor)

    valueEditorConfigurationManagerProvider
        .registerForType('text', TEXT_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('number', NUMBER_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('object', OBJECT_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('list', LIST_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('generable-text', GENERABLE_TEXT_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('text-or-select', TEXT_OR_SELECT_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('text-with-metadata', TEXT_WITH_METADATA_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('scannable-text', SCANNABLE_TEXT_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('year', {})
        .registerForType('date', DATE_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('html', HTML_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('password', PASSWORD_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('boolean', BOOLEAN_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('hidden', {})
        .registerForType('range', RANGE_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('autocomplete', AUTOCOMPLETE_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('search-or-edit', SEARCH_OR_EDIT_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('number-range', NUMBER_RANGE_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('single-acceptable', SINGLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('multiple-acceptable', MULTIPLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_OPTIONS)
        .registerForType('acceptable-root', ACCEPTABLE_ROOT_VALUE_EDITOR_DEFAULT_OPTIONS)


    valueEditorLocalizationManagerProvider
        .registerForType('text', TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('number', NUMBER_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('list', LIST_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('object', OBJECT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('generable-text', GENERABLE_TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('text-or-select', TEXT_OR_SELECT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('text-with-metadata', TEXT_WITH_METADATA_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('scannable-text', SCANNABLE_TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('year', YEAR_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('date', DATE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('html', HTML_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('password', PASSWORD_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('boolean', BOOLEAN_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('range', RANGE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('autocomplete', AUTOCOMPLETE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('search-or-edit', SEARCH_OR_EDIT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('number-range', NUMBER_RANGE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('single-acceptable', SINGLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('multiple-acceptable', MULTIPLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
        .registerForType('acceptable-root', ACCEPTABLE_ROOT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS)
}